import { z } from 'zod';
// Training deliberately repeats the public Workforce host literals instead of
// importing the optional Workforce package. Release-composition tests bind
// these values to the installed host when it exists.
export const trainingWorkforceProfileHostCapability = 'workforce.employee-profile-host.v1';
export const trainingWorkforceProfileHostFallbackCapability = 'training.degraded.workforce-employee-profile-host-unavailable.v1';
export const trainingWorkforceProfileHostSlot = 'workforce.employee-profile.status';
export const trainingWorkforceProfileHostResourceType = 'workforce.membership-profile';
export const trainingWorkforceProfileHostContextSchema = z.strictObject({
    resourceType: z.literal(trainingWorkforceProfileHostResourceType),
    resourceId: z.string().uuid(),
    parameters: z.strictObject({
        resourceLabel: z.string().trim().min(1).max(240),
    }),
});
//# sourceMappingURL=training-workforce-profile-host.contract.js.map